var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D5027DDF-A985-4447-A35A-A2787B518EC5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-check",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-20.7%",
    y: "-15.7%",
    width: "141.4%",
    height: "141.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.639999962,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.712505315   0 0 0 0 0.712505315   0 0 0 0 0.712505315  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Widgets-GMS-Agencias",
    transform: "translate(-1239.000000, -3862.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-App-User-Success",
    transform: "translate(1041.000000, 3838.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check",
    transform: "translate(201.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-check"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFE6E6",
    xlinkHref: "#path-check"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#C00000",
    strokeWidth: 1.27999992,
    fill: "#EDF8FF",
    xlinkHref: "#path-check"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(5.853659, 6.341463)",
    stroke: "#C00000",
    strokeLinecap: "round",
    strokeWidth: 1.70731697
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.243902439,4.63414634 L3.04363848,7.09335324",
    id: "Line-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.29268293,0.243902439 L3.10180276,6.99363733",
    id: "Line-2-Copy"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.c7035703fb00f59b15fd6c2d8ba911e5.svg";
export { ForwardRef as ReactComponent };